import { Locale } from '@klokhuis/core/Intl/types';

import {
  AnalyticsPageCategory,
  AnalyticsPageName,
  AnalyticsUserProperties,
} from '../types';

export function getPageViewedEventPayload(
  locale: string,
  pageName?: AnalyticsPageName,
  pageCategory?: AnalyticsPageCategory,
  pageProperties?: Record<string, unknown>,
  userProperties?: AnalyticsUserProperties,
): any {
  return {
    klokhuisApp: 'next',
    language: locale === Locale.en ? 'English' : 'Tamil',
    ...(pageName && { name: pageName }),
    ...(pageCategory && { category: pageCategory }),
    ...pageProperties,
    ...userProperties,
  };
}
